import React from 'react';
import { Typography } from 'fronton-react';
import { dimensionsAtom } from 'pages/dimensions/store/dimensions';
import { useRecoilValue } from 'recoil';
import { AddedProductsTitle, ComplementaryProductsBox, ComplimentaryProductInfoContainer } from './styles';
import { MainProduct } from './MainProduct';
import { ComplementaryProduct } from './ComplementaryProduct';

export const ComplementaryProductsComponent = () => {
  const dimensions = useRecoilValue(dimensionsAtom);

  const { complimentaryProductInfo } = dimensions;

  return (
    <ComplementaryProductsBox>
      <MainProduct />
      {!!complimentaryProductInfo.length && (
        <>
          <AddedProductsTitle>
            <Typography color="text-minor" size="body_short" variant="s">
              С этим товаром покупают
            </Typography>
          </AddedProductsTitle>
          <ComplimentaryProductInfoContainer>
            {complimentaryProductInfo.map((item, i) =>
              item.salesPriceValueInConsumerUnitValue ? (
                <ComplementaryProduct
                  product={item}
                  index={i}
                  isDisabled={!dimensions.checkedProducts[i].isChecked}
                  key={item.productId}
                />
              ) : null
            )}
          </ComplimentaryProductInfoContainer>
        </>
      )}
    </ComplementaryProductsBox>
  );
};
